import { Button } from 'react-bootstrap';
import React from 'react';
import { CloseIcon, DividerIcon } from '../../assets/icons';

export const YouTubeHeader = (props: { title: string; onClose: () => void }) => {
  const { title, onClose } = props;

  return (
    <div className="attachments-view__header-container">
      <div className="attachments-view__file-details">
        <div className="attachments-view__file-name" data-test="attachments-view__file-name">
          {title}
        </div>
      </div>
      <DividerIcon className="attachments-view__header-divider" />)
      <Button
        className="attachments-view__header-button"
        data-test="attachments-view__close-button"
        onClick={onClose}
      >
        <CloseIcon className="attachments-view__icon" />
      </Button>
    </div>
  );
};
